import React from 'react';
import './GrcSection.css';
import grcBanner from '../../assets/images/grc-banner.jpeg'; // Import the new image

const GrcSection = () => {
  // Define the style object for the background image
  const sectionStyle = {
    backgroundImage: `url(${grcBanner})`
  };

  return (
    <section className="grc-section" style={sectionStyle}>
      <div className="grc-background-overlay"></div>
      <div className="container grc-content">
        <div className="grc-text-content">
          <h2 className="grc-title">Smart technology with SAP GRC</h2>
          <p className="grc-description">
            SAP GRC enables organizations to adapt its technology to their specific compliance and risk management needs, enhancing its relevance and effectiveness.
          </p>
        </div>
        <div className="grc-features">
          {/* Feature 1: Governance */}
          <div className="grc-feature-card">
            <h3 className="feature-title">GOVERNANCE</h3>
            <p className="feature-description">
              Governance involves establishing policies, processes, and structures to ensure that organizational activities align with business and ethical standards.
            </p>
          </div>
          {/* Feature 2: Risk */}
          <div className="grc-feature-card">
            <h3 className="feature-title">RISK</h3>
            <p className="feature-description">
              Risk management is the process of identifying, assessing, mitigating, and monitoring potential threats or uncertainties that could impact the organization.
            </p>
          </div>
          {/* Feature 3: Compliance */}
          <div className="grc-feature-card">
            <h3 className="feature-title">COMPLIANCE</h3>
            <p className="feature-description">
              Compliance ensures that the organization adheres to laws, regulations, standards, and internal policies governing its operations.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GrcSection;
